"use strict";
/*
 * Collection: orgs/{orgId}/integrations/${integrationId}/secrets
 */
Object.defineProperty(exports, "__esModule", { value: true });
